
module.exports = function AutoSlugifyWidget (host, config) {

  // Setup
  var $target = $(config.targetInput);
  var $host   = $(host);

  // Functions
  function slugify (text) {
    return text.toLowerCase()  // everything to lowercase
      .replace(/['"]/g,  '')   // quotes and apostrophes go away
      .replace(/[^\w]/g, '-')  // non-letterlike symbols become hypen
      .replace(/[-]+/g,  '-'); // consolidate multiple hyphens
  }

  function update () {
    $host.val(slugify($target.val()));
  }

  // Listeners
  $target.on('change input paste blur', update);

  // Init
  if ($target.length < 1) {
    console.warn("AutoSlugifyWidget - can't find target with selector: " . config.targetInput);
    return {};
  }

  // Interface
  return {};

}

